export default __webpack_public_path__ + "static/media/products.a9c2001b.xlsx";